import { startCase, camelCase } from "lodash-es"

export const titleize = (sentence: string): string => startCase(camelCase(sentence))

type ValidPluralSuffixes = "s" | "es" | "ves" | "ies"

export const pluralize = (
  count: number,
  noun: string,
  suffix: ValidPluralSuffixes = "s",
  sliceCount = 0,
  skipZero = true,
) => {
  if (skipZero && (count === 0 || !noun)) return null
  const text = `${count} ${noun}`
  const usedSuffix = count === 1 || count === -1 ? "" : suffix
  return sliceCount ? `${text.slice(0, -sliceCount)}${usedSuffix}` : `${text}${usedSuffix}`
}
